import { render, staticRenderFns } from "./WorkAddress.vue?vue&type=template&id=2957186a&scoped=true&"
import script from "./WorkAddress.vue?vue&type=script&lang=ts&"
export * from "./WorkAddress.vue?vue&type=script&lang=ts&"
import style0 from "./WorkAddress.vue?vue&type=style&index=0&id=2957186a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2957186a",
  null
  
)

export default component.exports